"use client"

import { useMemo, useState } from "react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { Badge } from "../../../components/ui/badge"
import { Textarea } from "../../../components/ui/textarea"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog"
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../../components/ui/select"
import { Check, X, Flag, MessageSquare, Reply } from "lucide-react"

const _comments = [
  {
    id: 1,
    author: "John Doe",
    email: "john.doe@tso-emails.com",
    content: "Thank you for the wonderful sermon last Sunday. It really touched my heart.",
    page: "Sunday Service",
    status: "pending",
    date: "2024-01-06",
    replies: 0,
  },
  {
    id: 2,
    author: "Mary Smith",
    email: "mary.smith@tso-emails.com",
    content: "When is the next youth camp? My daughter is very interested in participating.",
    page: "Youth Ministry",
    status: "approved",
    date: "2024-01-05",
    replies: 1,
  },
  {
    id: 3,
    author: "Anonymous",
    email: "anonymous@tso-emails.com",
    content: "This is spam content that should be removed.",
    page: "Contact",
    status: "spam",
    date: "2024-01-04",
    replies: 0,
  },
]

// export function CommentModerationSection({allUsers,adminUsers,comments}:any) {
//   const [selectedComment, setSelectedComment] = useState<(typeof _comments)[0] | null>(null)
//   const [replyText, setReplyText] = useState("")

//   const getStatusBadgeVariant = (status: string) => {
//     switch (status) {
//       case "approved":
//         return "default"
//       case "pending":
//         return "secondary"
//       case "spam":
//         return "destructive"
//       case "rejected":
//         return "outline"
//       default:
//         return "outline"
//     }
//   }

//   const handleApprove = (commentId: number) => {
//     console.log("Approving comment:", commentId)
//   }

//   const handleReject = (commentId: number) => {
//     console.log("Rejecting comment:", commentId)
//   }

//   const handleMarkSpam = (commentId: number) => {
//     console.log("Marking as spam:", commentId)
//   }

//   const handleReply = () => {
//     if (selectedComment && replyText.trim()) {
//       console.log("Replying to comment:", selectedComment.id, "with:", replyText)
//       setReplyText("")
//     }
//   }

//   return (
//     <div className="space-y-6">
//       <Card>
//         <CardHeader>
//           <CardTitle>Comment & Feedback Moderation</CardTitle>
//           <CardDescription>Review, approve, and manage user comments and feedback</CardDescription>
//         </CardHeader>
//         <CardContent>
//           <div className="rounded-md border">
//             <Table>
//               <TableHeader>
//                 <TableRow>
//                   <TableHead>Author</TableHead>
//                   <TableHead>Comment</TableHead>
//                   <TableHead>Page</TableHead>
//                   <TableHead>Status</TableHead>
//                   <TableHead>Date</TableHead>
//                   <TableHead className="text-right">Actions</TableHead>
//                 </TableRow>
//               </TableHeader>
//               <TableBody>
//                 {_comments.map((comment:any) => (
//                   <TableRow key={comment.id}>
//                     <TableCell>
//                       <div>
//                         <div className="font-medium">{comment.author}</div>
//                         <div className="text-sm text-muted-foreground">{comment.email}</div>
//                       </div>
//                     </TableCell>
//                     <TableCell className="max-w-md">
//                       <p className="truncate">{comment.content}</p>
//                       {comment.replies > 0 && (
//                         <div className="flex items-center gap-1 mt-1 text-sm text-muted-foreground">
//                           <Reply className="h-3 w-3" />
//                           {comment.replies} reply(s)
//                         </div>
//                       )}
//                     </TableCell>
//                     <TableCell>{comment.page}</TableCell>
//                     <TableCell>
//                       <Badge variant={getStatusBadgeVariant(comment.status)}>{comment.status}</Badge>
//                     </TableCell>
//                     <TableCell>{comment.date}</TableCell>
//                     <TableCell className="text-right">
//                       <div className="flex justify-end gap-1">
//                         <Dialog>
//                           <DialogTrigger asChild>
//                             <Button variant="ghost" size="sm" onClick={() => setSelectedComment(comment)}>
//                               <MessageSquare className="h-4 w-4" />
//                             </Button>
//                           </DialogTrigger>
//                           <DialogContent className="max-w-2xl">
//                             <DialogHeader>
//                               <DialogTitle>Comment Details</DialogTitle>
//                               <DialogDescription>Review and manage this comment</DialogDescription>
//                             </DialogHeader>
//                             {selectedComment && (
//                               <div className="space-y-4">
//                                 <div>
//                                   <label className="text-sm font-medium">Author</label>
//                                   <p className="text-sm">
//                                     {selectedComment.author} ({selectedComment.email})
//                                   </p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Page</label>
//                                   <p className="text-sm">{selectedComment.page}</p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Comment</label>
//                                   <p className="text-sm bg-muted p-3 rounded">{selectedComment.content}</p>
//                                 </div>
//                                 <div>
//                                   <label className="text-sm font-medium">Reply (Optional)</label>
//                                   <Textarea
//                                     placeholder="Type your reply here..."
//                                     value={replyText}
//                                     onChange={(e) => setReplyText(e.target.value)}
//                                     className="mt-1"
//                                   />
//                                 </div>
//                                 <div className="flex gap-2 pt-4">
//                                   <Button onClick={handleReply} disabled={!replyText.trim()}>
//                                     Send Reply
//                                   </Button>
//                                   <Button variant="outline" onClick={() => handleApprove(selectedComment.id)}>
//                                     Approve
//                                   </Button>
//                                   <Button variant="outline" onClick={() => handleReject(selectedComment.id)}>
//                                     Reject
//                                   </Button>
//                                 </div>
//                               </div>
//                             )}
//                           </DialogContent>
//                         </Dialog>
//                         <Button variant="ghost" size="sm" onClick={() => handleApprove(comment.id)}>
//                           <Check className="h-4 w-4 text-green-600" />
//                         </Button>
//                         <Button variant="ghost" size="sm" onClick={() => handleReject(comment.id)}>
//                           <X className="h-4 w-4 text-red-600" />
//                         </Button>
//                         <Button variant="ghost" size="sm" onClick={() => handleMarkSpam(comment.id)}>
//                           <Flag className="h-4 w-4 text-orange-600" />
//                         </Button>
//                       </div>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//                 <h1>{JSON.stringify(comments)}</h1>
//               </TableBody>
//             </Table>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   )
// }

export function CommentModerationSection({ comments = [] }: any) {
  const [selectedComment, setSelectedComment] = useState<any | null>(null);
  const [replyText, setReplyText] = useState("");
  const [selectedPage, setSelectedPage] = useState("all");

  // Extract unique page slugs from comment links
  const pageOptions = useMemo(() => {
    const pages = new Set<string>();
    comments.forEach((comment: any) => {
      const match = comment.link.match(/\.com\/([^#]+)/);
      if (match && match[1]) pages.add(decodeURIComponent(match[1]));
    });
    return ["all", ...Array.from(pages)];
  }, [comments]);

  // Add computed 'page' and transformed structure
  const transformedComments = comments.map((c: any) => {
    const pageMatch = c.link.match(/\.com\/([^#]+)/);
    const page = pageMatch && pageMatch[1] ? decodeURIComponent(pageMatch[1]) : "Unknown";
    return {
      id: c.id,
      author: c.author_name || "Anonymous",
      email: "", // Email is not available in public comment JSON
      content: c.content?.rendered?.replace(/<[^>]+>/g, "") ?? "",
      page,
      status: c.status,
      date: new Date(c.date).toLocaleDateString(),
      replies: 0, // Adjust if you plan to load reply count later
      original: c,
    };
  });

  // Filter comments based on selected page
  const filteredComments = useMemo(() => {
    return selectedPage === "all"
      ? transformedComments
      : transformedComments.filter((c:any) => c.page === selectedPage);
  }, [selectedPage, transformedComments]);

  const getStatusBadgeVariant = (status: string) => {
    switch (status) {
      case "approved": return "default";
      case "pending": return "secondary";
      case "spam": return "destructive";
      case "rejected": return "outline";
      default: return "outline";
    }
  };

  const handleApprove = (commentId: number) => {
    console.log("Approving comment:", commentId);
  };

  const handleReject = (commentId: number) => {
    console.log("Rejecting comment:", commentId);
  };

  const handleMarkSpam = (commentId: number) => {
    console.log("Marking as spam:", commentId);
  };

  const handleReply = () => {
    if (selectedComment && replyText.trim()) {
      console.log("Replying to comment:", selectedComment.id, "with:", replyText);
      setReplyText("");
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Comment & Feedback Moderation</CardTitle>
          <CardDescription>Review, approve, and manage user comments and feedback</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="mb-4 flex justify-end">
            <Select onValueChange={setSelectedPage} defaultValue="all">
              <SelectTrigger className="w-64">
                <SelectValue placeholder="Filter by page" />
              </SelectTrigger>
              <SelectContent>
                {pageOptions.map((page) => (
                  <SelectItem key={page} value={page}>
                    {page === "all" ? "All Pages" : page}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Author</TableHead>
                  <TableHead>Comment</TableHead>
                  <TableHead>Page</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Date</TableHead>
                  <TableHead className="text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredComments.map((comment:any) => (
                  <TableRow key={comment.id}>
                    <TableCell>
                      <div>
                        <div className="font-medium">{comment.author}</div>
                        <div className="text-sm text-muted-foreground">{comment.email}</div>
                      </div>
                    </TableCell>
                    <TableCell className="max-w-md">
                      <p className="truncate">{comment.content}</p>
                      {comment.replies > 0 && (
                        <div className="flex items-center gap-1 mt-1 text-sm text-muted-foreground">
                          <Reply className="h-3 w-3" />
                          {comment.replies} reply(s)
                        </div>
                      )}
                    </TableCell>
                    <TableCell>{comment.page}</TableCell>
                    <TableCell>
                      <Badge variant={getStatusBadgeVariant(comment.status)}>{comment.status}</Badge>
                    </TableCell>
                    <TableCell>{comment.date}</TableCell>
                    <TableCell className="text-right">
                      <div className="flex justify-end gap-1">
                        <Dialog>
                          <DialogTrigger asChild>
                            <Button variant="ghost" size="sm" onClick={() => setSelectedComment(comment)}>
                              <MessageSquare className="h-4 w-4" />
                            </Button>
                          </DialogTrigger>
                          <DialogContent className="max-w-2xl">
                            <DialogHeader>
                              <DialogTitle>Comment Details</DialogTitle>
                              <DialogDescription>Review and manage this comment</DialogDescription>
                            </DialogHeader>
                            {selectedComment && (
                              <div className="space-y-4">
                                <div>
                                  <label className="text-sm font-medium">Author</label>
                                  <p className="text-sm">
                                    {selectedComment.author} ({selectedComment.email || "No email"})
                                  </p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Page</label>
                                  <p className="text-sm">{selectedComment.page}</p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Comment</label>
                                  <p className="text-sm bg-muted p-3 rounded">{selectedComment.content}</p>
                                </div>
                                <div>
                                  <label className="text-sm font-medium">Reply (Optional)</label>
                                  <Textarea
                                    placeholder="Type your reply here..."
                                    value={replyText}
                                    onChange={(e) => setReplyText(e.target.value)}
                                    className="mt-1"
                                  />
                                </div>
                                <div className="flex gap-2 pt-4">
                                  <Button onClick={handleReply} disabled={!replyText.trim()}>
                                    Send Reply
                                  </Button>
                                  <Button variant="outline" onClick={() => handleApprove(selectedComment.id)}>
                                    Approve
                                  </Button>
                                  <Button variant="outline" onClick={() => handleReject(selectedComment.id)}>
                                    Reject
                                  </Button>
                                </div>
                              </div>
                            )}
                          </DialogContent>
                        </Dialog>
                        <Button variant="ghost" size="sm" onClick={() => handleApprove(comment.id)}>
                          <Check className="h-4 w-4 text-green-600" />
                        </Button>
                        <Button variant="ghost" size="sm" onClick={() => handleReject(comment.id)}>
                          <X className="h-4 w-4 text-red-600" />
                        </Button>
                        <Button variant="ghost" size="sm" onClick={() => handleMarkSpam(comment.id)}>
                          <Flag className="h-4 w-4 text-orange-600" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
